import { useState } from 'react';
import toast from 'react-hot-toast';
import Axios from '../../utils/Axios';
import SummaryAPI from '../../common/SummaryAPI.js';
import AxiosToastError from '../../utils/AxiosToastError';
import { Link, useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmail((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const isValid = Object.values(email).every(val => val); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await Axios({
        ...SummaryAPI.forgot_password,
        data:{email} 
      });

      const res = response.data;

      if (res.error) {
        toast.error(res.message);
        return;
      }

      if (res.success) {
        toast.success(res.message);
        navigate("/otp-verification", { state: {email} });
        setEmail({ email: "" });
      }
    } catch (error) {
      AxiosToastError(error);
      console.log(error);
    }
  };

  return (
    <div>
      <h2>Forgotten Password?</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor='email'>Email:</label>
        <input
          type='email'
          id='email'
          name='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
        />
        <button type="submit" disabled={!email}>Send OTP</button>
      </form>
      <p>
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default ForgotPassword;
